import { useState, useEffect } from 'react';
import { fetchWithToken } from '../../../api/apiutils';

export const useDictionaries = (dictKeys = []) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dictKeys.length === 0) return;

    const load = async () => {
      setIsLoading(true);
      try {
        const results = await Promise.all(
          dictKeys.map(async (key) => {
            const res = await fetchWithToken(`/api/dictionary/${key}`);
            if (!res.ok) throw new Error(`Ошибка загрузки словаря ${key}`);
            const json = await res.json();
            return [key, json];
          })
        );
        setData(Object.fromEntries(results));
      } catch (err) {
        console.error('Ошибка загрузки справочников:', err);
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [dictKeys]);

  return { data, isLoading };
};
